<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth>750">
      <div class="log-box">
        <img src="@/assets/logo.png" alt="">
        <span>Sarana Sumatera Barat Ventura</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex===0)?'choice':''">Home</div>
        <div @click="choiceMenu(1)" :class="(menuIndex===1)?'choice':''">Produknya</div>
        <div @click="choiceMenu(2)" :class="(menuIndex===2)?'choice':''">Profil Perusahaan</div>
        <div @click="choiceMenu(3)" :class="(menuIndex===3)?'choice':''">Keuntungan</div>
        <!-- <div @click="choiceMenu(4)" :class="(menuIndex===4)?'choice':''">Our Lending Partners</div> -->
        <!-- <div @click="choiceMenu(5)" :class="(menuIndex===5)?'choice':''">Privacy Policy</div>
        <div @click="choiceMenu(6)" :class="(menuIndex===6)?'choice':''">Partners</div> -->
      </div>
    </div>
    <div id='step_1' ref="step_1" class="ref-home"></div>

    <div class="banner-box" id='home' ref="home">
      <img src="../assets/banner.png" class="banner">
      <div class="app-name">
        <div>Sarana Sumatera Barat Ventura</div>
        <p>Salah satu perusahaan fintech paling profesional di Indonesia</p>
      </div>
    </div>

    <div class="list-box">
      <div class="list">
        <div class="setp-box">
          <img src="../assets/list-1.png" class="list-img">
          <div class="title">Subsidi perumahan</div>
          <div class="text">Memberikan subsidi perumahan bagi karyawan untuk menciptakan lingkungan hidup yang lebih baik</div>
        </div>
        <div class="setp-box">
          <img src="../assets/list-2.png" class="list-img">
          <div class="title"> Layanan berkualitas tinggi</div>
          <div class="text">Kami selalu menjaga hubungan kerja yang baik dengan pelanggan, berharap dapat menyediakan layanan bintang lima kepada pelanggan </div>
        </div>
        <div class="setp-box">
          <img src="../assets/list-3.png" class="list-img">
          <div class="title">Profesionalisme yang sangat baik</div>
          <div class="text"> kualitas profesional yang sangat baik dan kemampuan profesional</div>
        </div>
        <div class="setp-box">
          <img src="../assets/list-4.png" class="list-img">
          <div class="title"> Pembangunan berkelanjutan</div>
          <div class="text"> mengoptimalkan tujuan strategis dan meningkatkan pengembangan bisnis</div>
        </div>
      </div>
    </div>

    <div id='step_2' ref="step_2"></div>
    <div class="dear_rupiah">
      <div class="title">Dompet Now</div>
      <a href="https://dompetnow.com">
        <img src="../assets/1024.png" class="p-logo">
      </a>
      <div class="logo-text">
        Dompet Now adalah platform keuangan online yang dirancang khusus untuk masyarakat Indonesia yang dikembangkan oleh PT Dompet Now, anak perusahaan Sarana Sumatera Barat Ventura, untuk mengatasi kesulitan keuangan yang dihadapi pengguna.
      </div>
    </div>

    <div id='step_3' ref="step_3"></div>
    <div class="company_details">
      <img src="../assets/img-1.png" class="img-1">
      <div class="text">
        <div class="title">Pengenalan perusahaan Sarana Sumatera Barat Ventura</div>
        <p>Sarana Sumatera Barat Ventura telah disahkan oleh Badan Pengawas OJK dan berlokasi di Jl. KH. Hasyim Ashari No. 13A, RT. 017/008, Petojo Utara, Gambir, Jakarta Pusat DKI Jakarta. Memiliki taman mandiri dengan lebih dari 1.000 karyawan , Ada rencana insentif karyawan yang berkelanjutan setiap tahun. Karyawan dapat dipromosikan dalam suasana kerja yang baik. Karyawan yang unggul dipilih secara teratur untuk bekerja sama dengan universitas terkemuka untuk meningkatkan kualitas dan kemampuan kerja mereka.</p>
      </div>
    </div>
    <div id='step_4' ref="step_4"></div>
    <div class="picture_wall">
      <div class="title">Keunggulan Sarana Sumatera Barat Ventura</div>
      <div class="wall-box">
        <div class="list-5 ">
          <div class="wall-img-text">
            <div>Kerja tim</div>
            <p> tim yang luar biasa adalah fondasi kesuksesan</p>
          </div>
        </div>
        <div class="list-6 wall-text">
          <div class="wall-img-text">
            <div>Lembaga profesional</div>
            <p> lembaga keuangan profesional bertanggung jawab atas pelanggan</p>
          </div>
        </div>
        <div class="list-7 wall-text">
          <div class="wall-img-text">
            <div> Keuangan Internet</div>
            <p> terintegrasi erat dengan Internet</p>
          </div>
        </div>
        <div class="list-8 wall-text">
          <div class="wall-img-text">
            <div> Mitra berkualitas tinggi</div>
            <p>memiliki mitra industri terkemuka</p>
          </div>
        </div>
        <div class="list-9 wall-text">
          <div class="wall-img-text">
            <div> Waktu luang dan hiburan</div>
            <p>perusahaan menyediakan lingkungan waktu luang dan hiburan yang baik untuk memenuhi kebutuhan waktu luang karyawan</p>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <!-- <div class="title">Contact Us </div> -->
      <div class="flex-footer-content">
        <!-- <div class="box">
          <img src="@/assets/tel.png" class="mail-img">
          <div class="text">5156867204 </div>
        </div> -->
        <!-- <div class="box">
          <img src="@/assets/mail.png" class="mail-img">
          <div class="text">effg43534fdg@gmail.com</div>
        </div> -->
        <div class="box">
          <img src="@/assets/address.png" class="mail-img">
          <div class="text">Gedung Rangkiang Ventura Kav. 5-7 Jl. Khatib Sulaiman No.9 RT 002/013 Kel. Gunung Pangilun, Kec. Padang Utara</div>
        </div>
      </div>
    </div>
    <div class="copyright">© Copyright by Sarana Sumatera Barat Ventura.</div>
  </div>
</template>

<script>
import privacy from "@/components/privacy";
export default {
  name: 'App',
  components: {
    privacy
  },
  data () {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let item = this.$route.query.item
    console.log(item);
    if (item == 'partners') {
      this.$nextTick(() => {
        setTimeout(() => {
          this.choiceMenu(1)
        }, 1000);
      })
    }
  },
  methods: {
    choiceMenu (index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("step_1").scrollIntoView(); break;
        case 1: document.getElementById("step_2").scrollIntoView(); break;
        case 2: document.getElementById("step_3").scrollIntoView(); break;
        case 3: document.getElementById("step_4").scrollIntoView(); break;
        case 4: document.getElementById("step_5").scrollIntoView(); break;
        case 5: document.getElementById("step_6").scrollIntoView(); break;
        case 6: document.getElementById("step_7").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick () {
      this.showMenu = !this.showMenu
    },
    gotoPrivacy () {
      this.$router.push({
        path: "/Privacy",
      });
    }
  }
}
</script>


<style lang="less" >
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
